import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, DateDecoder, IntegerDecoder, StringDecoder, field } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { upgradePriceFrom2To4DecimalPlaces } from '../upgradePriceFrom2To4DecimalPlaces.js';
export class MemberPlatformMembership extends AutoEncoder {
    id;
    memberId;
    membershipTypeId;
    organizationId;
    periodId;
    startDate = new Date();
    trialUntil = null;
    endDate = new Date();
    expireDate = null;
    balanceItemId = null;
    price = 0; // null is used to hide the price if user lacks permission
    priceWithoutDiscount = 0; // null is used to hide the price if user lacks permission
    freeAmount = 0;
    generated = false;
    createdAt = new Date();
    updatedAt = new Date();
    // prevent deleting or changing price if true
    locked = false;
    isActive(date = new Date()) {
        return this.startDate <= date && this.endDate >= date;
    }
    get isTrial() {
        return this.trialUntil !== null && (this.trialUntil > new Date() || this.endDate <= this.trialUntil);
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], MemberPlatformMembership.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberPlatformMembership.prototype, "memberId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberPlatformMembership.prototype, "membershipTypeId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberPlatformMembership.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberPlatformMembership.prototype, "periodId", void 0);
__decorate([
    field({ decoder: DateDecoder })
], MemberPlatformMembership.prototype, "startDate", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true, version: 354 })
], MemberPlatformMembership.prototype, "trialUntil", void 0);
__decorate([
    field({ decoder: DateDecoder })
], MemberPlatformMembership.prototype, "endDate", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], MemberPlatformMembership.prototype, "expireDate", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MemberPlatformMembership.prototype, "balanceItemId", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces }),
    field({ decoder: IntegerDecoder, nullable: true, version: 421, downgrade: (newValue) => newValue ?? 0 })
], MemberPlatformMembership.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces }),
    field({ decoder: IntegerDecoder, nullable: true, version: 421, downgrade: (newValue) => newValue ?? 0 })
], MemberPlatformMembership.prototype, "priceWithoutDiscount", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 336 })
], MemberPlatformMembership.prototype, "freeAmount", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], MemberPlatformMembership.prototype, "generated", void 0);
__decorate([
    field({ decoder: DateDecoder })
], MemberPlatformMembership.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], MemberPlatformMembership.prototype, "updatedAt", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 364 })
], MemberPlatformMembership.prototype, "locked", void 0);
//# sourceMappingURL=MemberPlatformMembership.js.map